export interface TaskCodeResponse {
	feeTaskCodes: FeeTaskCode[];
	costRecoveryTaskCodes: CostRecoveryTaskCode[];
	taxCodes: LeapTaxCode[];
}

export interface CostRecoveryTaskCode {
	taskCodeId: string;
	purchaseSupplierCardId: string | null;
	taxCodeId: string;
	purchaseMode: number | null;
	deleted: boolean;
	nameFileAs: string;
	billingDescription: string;
	incTax: boolean;
	amountEach: number;
	groupOnInvoice: boolean;
}

export interface FeeTaskCode {
	taskCodeId: string;
	taxCodeId: string;
	nameFileAs: string;
	billingDescription: string;
	groupOnInvoice: boolean;
	deleted: boolean;
	amountRate: number;
	incTax: boolean;
	rateId: number;
	timed: boolean;
	calculationMode: number;
	calculationScript?: string;
	rowVersion: number;
	billingMode: number;
}

export const leapNullItemFeeTaskCode: FeeTaskCode = {
	taskCodeId: '00000000-0000-0000-0000-000000000000',
	nameFileAs: 'N/A',
	amountRate: 0,
	billingDescription: '',
	billingMode: 0,
	calculationMode: 0,
	deleted: false,
	groupOnInvoice: false,
	incTax: false,
	rateId: 0,
	rowVersion: 0,
	taxCodeId: '00000000-0000-0000-0000-000000000000',
	timed: false,
};

export const leapNullItemCostRecoveryTaskCode: CostRecoveryTaskCode = {
	taskCodeId: '00000000-0000-0000-0000-000000000000',
	nameFileAs: 'N/A',
	amountEach: 0,
	billingDescription: '',
	deleted: false,
	groupOnInvoice: false,
	incTax: false,
	purchaseMode: 0,
	purchaseSupplierCardId: null,
	taxCodeId: '00000000-0000-0000-0000-000000000000',
};

export interface LeapTaxCode {
	firmId: string;
	ratePercent: number;
	taxCodeId: string;
	glTaxCode: string;
	taxCode: string;
	glTaxCodeType: string;
	deleted: boolean;
	taxCodeDescription: string;
	rowVersion: number;
	taxCodeSplits: TaxCodeSplits[];
	isGroupTaxCode: boolean;
	isTaxCodeUsable: boolean;
}

export interface TaxCodeSplits {
	taxCodeId: string;
	sequence: number;
}

export interface LeapCard {
	cardId: string;
	personId: string;
}
